import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { DegreeParticipation } from '../../../models/backend-definitions.module';
import { PageOptions } from '../../../util/backend-util-module';

@Injectable()
export class DegreeParticipationListProvider implements Resolve<any> {
    degreeParticipation: DegreeParticipation[];
    degreeParticipationEdit: DegreeParticipation;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        if (this.state?.currentPage && state.url.includes(this.state?.path)) {
            this.currentPage = this.state?.currentPage;
        }
        this.degreeParticipationEdit = this.state?.currentDegreeParticipation;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<DegreeParticipation> {
        if (!id) {
            return null;
        }
        return this.gw.get('degreeParticipation/:id', { id: id });
    }

    get currentdegreeParticipation(): DegreeParticipation {
        return this.degreeParticipationEdit;
    }

    getById(id: number): Observable<DegreeParticipation> {
        if (!id) {
            return null;
        }
        return this.gw.get('kit/:id', { id: id });
    }

    getAll(entity?: String): Promise<any> {
        let urlPath = 'degreeParticipation/';
        if (entity) {
            urlPath = entity + urlPath;
        }
        return new Promise((resolve, reject) => {
            this.gw.get(urlPath).subscribe((res: HttpResponse<any>) => {
                this.degreeParticipation = res.body;
                this.onDataChanged.next(this.degreeParticipation);
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('degreeParticipation/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.degreeParticipation, res.body.content) && res.body.content.length > 0) {
                    this.degreeParticipation = res.body.content;
                    this.onDataChanged.next(this.degreeParticipation);
                } else {
                    this.degreeParticipation = res.body.content;
                }
                resolve(res);
            }, reject);
        });
    }

    getdegreeParticipationType(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('degreeParticipation/degreeParticipationType/simpleList')
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

